export default "__VITE_ASSET__ac4088ee__"